const initialState = {
  missions: [],
  rockets: [],
};

export default initialState;
